import React, { useState, useEffect, useContext } from 'react';
import { useQuery } from "@tanstack/react-query";
import { NuevaONGContext, useONGs } from '../context/NuevaONGContext';
import { useFormContext } from '../context/FormContext';

import Select from 'react-select';
import { Select_simple, Label, Input } from './ui';
import { optionsTipoSubsidio } from '../datos/options';

//const SubsidioForm = ({ tipoSubsidio, onTipoSubsidioChange, organismoSolicitante, onOrganismoSolicitanteChange, organismoOtro, onOrganismoOtroChange }) => {
const SubsidioForm = () => { //sin recibir props

    const { nuevaONG } = useContext(NuevaONGContext);
    const { formA, updateField } = useFormContext();
    const { datosGenerales } = formA;

    // 2. Movemos los manejadores al componente
    const handleTipoSubsidioChange = (newSubsidio) => {
        updateField('formA', 'datosGenerales', 'tipo_subsidio', newSubsidio);
    }

    const handleOrganismoSolicitanteChange = (value) => {
        updateField('formA', 'datosGenerales', 'organismo_solicitante', value || '');
    }

    const handleOrganismoOtroChange = (value) => {
        updateField('formA', 'datosGenerales', 'organismo_otro', value || '');
    }
    useEffect(() => {
        if (nuevaONG) {            
            cargarOpcionesONG();
        }
    }, [nuevaONG]); // El efecto se ejecutará cuando nuevaONG cambie  

    //24-abr-2025: estado para las options recibidas desde la api
    const [opcionesONG, setOpcionesONG] = useState([]);

    //para resetear organismo solicitante cuando el tipo de subsidio es Subsidio a municipio o Otro - 12-MAY-25    
    useEffect(() => {
        if(datosGenerales?.tipo_subsidio === 'Subsidio a municipio'){
            //console.log("ENTROO SUBSIDIO A MUNICIPIO ???")
            
            if(datosGenerales?.organismo_otro !== ""){
                handleOrganismoOtroChange("") //onOrganismoOtroChange
            } else if(datosGenerales?.organismo_solicitante !== ""){
                handleOrganismoSolicitanteChange("")
            }

        } else if(datosGenerales?.tipo_subsidio === 'Otro'){
            handleOrganismoSolicitanteChange("")
        } else if(datosGenerales?.tipo_subsidio === 'Subsidio a ONG'){
            handleOrganismoOtroChange("")
        }
    }, [datosGenerales?.tipo_subsidio])
    

    const cargarOpcionesONG = async () => {
        try {
            const respuesta = await fetch('/api/ongs');//todasONGS
            if (!respuesta.ok) {
                throw new Error(`HTTP error! status: ${respuesta.status}`);
            }
            const data = await respuesta.json();
            // Asumiendo que la API devuelve un array de objetos con propiedades como 'id' y 'nombre'
            const opcionesFormateadas = data.map(item => ({
                value: item.nombre, //item.id, // El valor que se enviará al seleccionar
                label: `${item.nombre} - Res: ${item.resolucion} - Cod: ${item.codigo}`//item.nombre, // El texto que se mostrará en el Select
            }));
            //setOpcionesReferente(opcionesFormateadas);
            // Agregar la opción por defecto al inicio del array
            setOpcionesONG([{ value: null, label: 'Seleccionar...' }, ...opcionesFormateadas]);
        } catch (error) {
            console.error("Error al cargar los referentes:", error);
            // Aquí podrías mostrar un mensaje de error al usuario
        }
    };

    useEffect(() => { 
        if(datosGenerales?.tipo_subsidio === 'Subsidio a ONG'){
            cargarOpcionesONG();
        }    
    }, [datosGenerales?.tipo_subsidio]); // El array vacío asegura que el efecto se ejecute solo una vez al montar el componente

    
    return (
        <div className="space-y-4">
            <div>
                <Label htmlFor="tipoSubsidio" className="block text-sm font-medium text-gray-700">
                    Tipo de subsidio
                </Label>                
                <Select_simple
                    id="tipo_subsidio"
                    name="tipo_subsidio"
                    options={optionsTipoSubsidio}
                    value={datosGenerales?.tipo_subsidio || ''}
                    onChange={(e) => handleTipoSubsidioChange(e.target.value)}//onTipoSubsidioChange
                    placeholder="Seleccionar..."
                />    
            </div>

            {datosGenerales?.tipo_subsidio === 'Subsidio a ONG' && (
                <div>
                    <Label htmlFor="nombreONG" className="block text-sm font-medium text-gray-700">
                        Nombre ONG
                    </Label>
                    <Select
                        id="nombreONG"
                        options={opcionesONG}
                        value={datosGenerales?.organismo_solicitante ? opcionesONG.find(ong => ong.value === datosGenerales?.organismo_solicitante) : null}
                        onChange={(e) => handleOrganismoSolicitanteChange(e.value)}//onOrganismoSolicitanteChange
                        classNamePrefix="select"
                        placeholder="Buscar ONG..."
                        isSearchable
                        classNames={{
                            control: () => "border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white h-9",
                        }}
                    />
                </div>
            )}            

            {datosGenerales?.organismo_solicitante && (
                <div>
                    <p className="text-sm text-gray-500">
                        ONG Seleccionada: {datosGenerales?.organismo_solicitante}
                    </p>
                    {/* Aquí podrías mostrar más detalles de la ONG si lo necesitas */}
                </div>
            )}

            {datosGenerales?.tipo_subsidio === 'Otro' && (
                <div>
                    <Label htmlFor="organismoOtro" className="block text-sm font-medium text-gray-700">
                        Organismo otro
                    </Label>
                    <Input
                        id="organismoOtro"
                        name="organismoOtro"
                        type="text"
                        placeholder="Organismo otro"
                        value={datosGenerales?.organismo_otro || ''}
                        onChange={e => handleOrganismoOtroChange(e.target.value)}//onOrganismoOtroChange
                    />
                </div>
            )}
        </div>
    );
};

export default SubsidioForm;